export const environment = {
  production: false,
  webApiUrl: "https://fw4v1qhxl3.execute-api.us-east-1.amazonaws.com/develop",
  keyGoogle: "***REMOVED***",
  recaptcha: {
    siteKey: '6LcW31MqAAAAAAcVGQCU4JKd3NBckNh1kQxSWcS1',
  },
};

